import { useTable, usePagination } from "react-table";
import { Table, Button } from "react-bootstrap";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export const DataTablePagination = ({
  columns,
  data,
  onRowClick,
  hiddenColumns = [],
}) => {
  const { t } = useTranslation();
  const [selectedRow, setSelectedRow] = useState(null);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page, // Instead of using 'rows', we'll use page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, hiddenColumns: hiddenColumns },
    },
    usePagination,
  );

  return (
    <>
      {/* Add a wrapper with overflow-x for horizontal scroll */}
      <div style={{ overflowX: "auto", maxWidth: "100%" }}>
        <Table
          striped
          hover
          size="lg"
          bordered={false}
          borderless={false}
          {...getTableProps()}
        >
          <thead>
            {headerGroups.map((headerGroup, index) =>
              index > 0 ? (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <th {...column.getHeaderProps()}>
                      {column.render("Header")}
                    </th>
                  ))}
                </tr>
              ) : null,
            )}
          </thead>
          <tbody {...getTableBodyProps}>
            {page.map((row, i) => {
              prepareRow(row);
              const isSelected = selectedRow === row.id;
              return (
                <tr
                  {...row.getRowProps()}
                  style={{ background: isSelected ? "#bbe6fa" : "inherit" }}
                  onClick={() => {
                    setSelectedRow(row.id);
                    onRowClick?.(row.original);
                  }}
                >
                  {row.cells.map((cell) => {
                    return (
                      <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>

      <div
        className="pagination d-flex flex-wrap justify-content-center align-items-center mt-3"
        style={{ gap: "8px" }}
      >
        <div className="d-flex align-items-center">
          <Button
            className="btn-primary rounded-0 rounded-left"
            onClick={() => gotoPage(0)}
            disabled={!canPreviousPage}
          >
            {"<<"}
          </Button>{" "}
          <Button
            className="btn-primary rounded-0"
            onClick={() => previousPage()}
            disabled={!canPreviousPage}
          >
            {"<"}
          </Button>{" "}
          <Button
            className="btn-primary rounded-0"
            onClick={() => nextPage()}
            disabled={!canNextPage}
          >
            {">"}
          </Button>{" "}
          <Button
            className="btn-primary rounded-0 rounded-right"
            onClick={() => gotoPage(pageCount - 1)}
            disabled={!canNextPage}
          >
            {">>"}
          </Button>{" "}
        </div>

        <span>
          {t("pagination.page")}{" "}
          <strong>
            {pageIndex + 1} {t("pagination.of")} {pageOptions.length}
          </strong>
        </span>

        <span>
          {t("pagination.goToPage")}{" "}
          <input
            type="number"
            defaultValue={pageIndex + 1}
            onChange={(e) => {
              const page = e.target.value ? Number(e.target.value) - 1 : 0;
              gotoPage(page);
            }}
            style={{ width: "60px", height: "38px", marginLeft: "5px" }}
          />
        </span>

        <select
          value={pageSize}
          onChange={(e) => setPageSize(Number(e.target.value))}
          style={{ height: "38px" }}
        >
          {[10, 20, 30, 40, 50].map((pageSize) => (
            <option key={pageSize} value={pageSize}>
              {t("pagination.show")} {pageSize}
            </option>
          ))}
        </select>
      </div>
    </>
  );
};
